import(/* webpackMode: "eager", webpackExports: ["VirtualTryOnView"] */ "/app/apps/frontend/components/virtual-try-on/view.tsx");
